/** Build an Atlassian browse URL from org base URL + project/space key + issue id. */

export function normalizeJiraBaseUrl(baseUrl: string | null | undefined): string {
  return String(baseUrl || '')
    .trim()
    .replace(/\/+$/, '');
}

export function buildJiraBrowseUrl(
  baseUrl: string | null | undefined,
  spaceKey: string | null | undefined,
  jiraId: string | number | null | undefined,
): string | null {
  const base = normalizeJiraBaseUrl(baseUrl);
  const key = String(spaceKey || '')
    .trim()
    .toUpperCase();
  const id = String(jiraId ?? '').trim();
  if (!base || !key || !id) return null;
  return `${base}/browse/${key}-${id}`;
}
